/**
 * @example
 * window.assetLoad = {
 *  // just load a file
 *  "actionName": {
 *    asset: 'filename'
 *  },
 *  // execute an action an include source
 *  "actionName": {
 *    asset: {
 *      path: 'filename',
 *      wrap: 'class-name'
 *      parent: 'css-selector'
 *      position: 'prepend'||'append' // in container
 *  }
 *  // thats how the AjaxShortcode class generates the js-source automatically
 *  "actionName": {
 *    args: {post data for ajax call}
 *    container: {tag to be replaced with content}
 *    nonce: {for wordpress}
 * }
 *
 * response of ajax calls could be a string containing html only or an object
 * containing the keys js, css, html to be included
 *
 * @todo callback processing for loadAsset function => create method based on source in attach method
 * @todo pathes to assets with optional hostname
 * @todo optional nonce
 * @todo get away from jQuery
 */
var oyc = oyc || {};
oyc.AssetLoader = {
  origin: window.location.origin || window.location.protocol + '//' + window.location.host, // to be used for local requests
  cache: {}, // not used so far
  varName: 'assetLoad', // name of the config var
  callbackActions: [], // collects all actions with a callback
  /**
   * walking through the configuration
   * @returns {undefined}
   */
  init: function () {
    "use Strict";
    if (this.varName in window) {
      $.ajaxSetup({cache: true}); // cache the requests
      for (var action in window[this.varName]) {
        let cConfig = window[this.varName][action];
        let args = {
          action: action,
          nonce: cConfig.nonce
        };
        if (typeof cConfig === 'object') {
          if ('asset' in cConfig) {
            let request = this.loadAsset(cConfig.asset);
            if ('callback' in cConfig) {
              if (typeof cConfig.callback === 'function') {
                request.then(cConfig.callback());
              } else if (typeof cConfig.callback === 'string') {
                console.log('callback is a string');
              }
            }
          }
        }
      }
    }
  },
  /**
   * inserts markup after loading
   * @param {String} data should be markup
   * @param {Object} config
   * @returns {undefined}
   */
  insertAsset: function (data, config) {
    let html = data;
    if (config.selector) {
      html = $(data).find(config.selector);
    }
    let parent = $(config.parent || 'body');
    if (parent.length > 0) {
      let position = config.position || 'append';
      if (typeof config.wrap !== 'undefined') {
        let wrap = $('<div class="' + config.wrap.replace(/[^a-z\-0-9]/i, '') + '">');
        html = wrap.append(html);
      }
      try {
        parent[position](html);
      } catch (e) {
        console.log(e.message);
        console.log('fallback to append the markup');
        parent.append(html)
      }
    }
  },
  /**
   * callback function for promises of a request
   * parses the response determining its type (String with markup or JSON) and attach Element/Assets
   * @param {mixed} data
   * @param {String} status
   * @param {jqXHR} xhr
   * @returns {undefined}
   */
  attach: function (data, status, xhr) {
    var response = null;
    try {
      if (typeof data !== 'object') {
        response = jQuery.parseJSON(data);
      }
    } catch (err) {
      response = {html: data};
    }
    oyc.AssetLoader.attachHtml(response.html);
    // attach all assets included in response and collect all Promises in an array
    var requests = [].concat.apply([], [
      oyc.AssetLoader.attachAssets(response.css),
      oyc.AssetLoader.attachAssets(response.js)
    ]);
    // look up for a callback function to be executed after all assets from the response are loaded
    if ('callback' in response) {
      let callback = response.callback;
      let callbackFunction = function () {
        if (typeof callback === 'string') {
          window[callback]();
        } else if (typeof callback === 'object' && 'obj' in callback) {
          window[callback.obj][callback.func || 'init']();
          callback = callback.obj;
        }
        oyc.AssetLoader.callbackActions.push(callback);
      };
      let index = oyc.AssetLoader.callbackActions.indexOf(response.callback.obj || response.callback);
      if (index > -1) {
        callbackFunction();
      } else {
        Promise.all(requests).then(callbackFunction).catch(function (err) {
          console.log(err);
        });
      }
    }
  },
  /**
   * inserts the markup from the response of an ajax request
   * a containers content is replaced, so a DOMelement has to exist having the same id as given by the container in the markup
   * @param {String} markup
   * @returns {undefined}
   */
  attachHtml: function (markup) {
    if (typeof markup !== 'undefined') {
      var container = $(markup);
      $('#' + container.attr('id')).html(container.html());
    }
  },
  /**
   * iterate through assets to be loaded from a response of an ajax request
   * @param {type} files
   * @returns {Array} contaning Promises for loading assets from a response of a previous request
   */
  attachAssets: function (files) {
    var requests = [];
    if (typeof files !== 'undefined') {
      var assets = [];
      if (typeof files === 'string') {
        assets.push(files);
      } else if (typeof files.push === 'function') {
        assets = files;
      }
      for (var i in assets) {
        if (assets[i].match(/(https?)?:\/\//) === null) {
          assets[i] = this.origin + assets[i];
        }
        // if we are handling css files use loadCss lib if available
        if (assets[i].match(/css/) && typeof loadCSS == 'function') {
          loadCSS(assets[i]);
        } else {
          requests.push(this.loadAsset(assets[i]));
        }
      }
    }
    return requests;
  },
  /**
   * function to load a single ressource (js, css or svg)
   * can be called anytime
   * @param {type} asset
   * @returns {Promise}
   */
  loadAsset: function (asset) {
    if (typeof asset === 'object') {
      var ajaxParams = {};
      // request allowing to load svgs or other documentElements into the dom even for IE (that's why its a little confusing)
      $.ajax(asset.path, ajaxParams).done(function (data, textStatus, jqXhr) {
        if (textStatus === 'success') {
          var importedRootElement = null;
          if (typeof data === 'object' && 'documentElement' in data) {
            importedRootElement = document.importNode(data.documentElement, true);
          } else if (typeof data === 'string') {
            importedRootElement = $(data).find('svg');
          }
          if (importedRootElement !== null || ('length' in importedRootElement && importedRootElement.length > 0)) {
            oyc.AssetLoader.insertAsset(importedRootElement, asset);
          }
        }
      });
    } else {
      // check type of asset from file extension
      let extension = asset.match(/\.(js|css)(\?|$)/);
      if (extension === null) {
        // extension ont determined yet - lookup implied we ahve an url
        extension = asset.match(/https?:\/\/.*\/(css|js)[\/\?]/);
      }
      if (extension === null) {
        extension = 'js';
      } else {
        extension = extension[1];
      }
      return oyc.AssetLoader.createElement(asset, extension);
    }
  },
  /**
   * building a script- or link-tag to include an asset returning a Promises
   * @param {String} asset the url to load
   * @param {String} type the type of the asset
   * @returns {Promise}
   */
  createElement: function (asset, type) {
    let tag = '';
    switch (type) {
      case 'css':
        tag = 'link';
        break;
      case 'js':
        tag = 'script'
        break;
    }
    // Promise.all will use this promise to determine success or failure
    return new Promise(function (resolve, reject) {
      if (asset in oyc.AssetLoader.cache) {
        resolve(asset); // Asset wurde bereits geladen
        return true;
      }
      oyc.AssetLoader.cache[asset] = true;
      const element = document.createElement(tag);
      let parent = 'body';
      let attr = 'src';
      // Important success and error for the promise
      element.onload = function () {
        resolve(asset);
      };
      element.onerror = function () {
        reject(asset);
      };
      // Need to set different attributes depending on tag type
      switch (tag) {
        case 'script':
          break;
        case 'link':
          element.type = 'text/css';
          element.rel = 'stylesheet';
          attr = 'href';
          parent = 'head';
          break;
      }

      // replace placeholder assets - a shortcut for paths to files to inlclude (js, css, img and so on
      element[attr] = asset.replace(/^(?:\/?\.\.)*\/?assets\//, (location.href.match('templating') ? location.href.replace(/\/[^\/]+$/, '/') : oyc.static.assetPath + '/'));
      // Inject into document to kick off loading
      document[parent].appendChild(element);
    });
  }
};
